import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { TreatmentsComponent } from './treatments.component';
import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { EditTreatmentDialogModule } from '../../components/edit-treatment-dialog/edit-treatment-dialog.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        EditTreatmentDialogModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        TreatmentsComponent,
    ],
    exports: [
        TreatmentsComponent
    ]
})
export class TreatmentsModule { }
